import { render, staticRenderFns } from "./Stage3.vue?vue&type=template&id=18e1d9a8&"
import script from "./Stage3.vue?vue&type=script&lang=js&"
export * from "./Stage3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports